import { ReactNode, useState } from 'react'
import { useAsync } from 'react-use'

import RegionsContext from 'components/contexts/RegionsContext'
import { Region } from 'types/Region'
import fetchRegions from 'utils/fetchRegions'

interface RegionsProviderProps {
  children?: ReactNode
}

const RegionsProvider = ({ children }: RegionsProviderProps): JSX.Element => {
  const [regionsList, setRegionsList] = useState<Region[]>([])

  useAsync(async () => {
    const regionsList = await fetchRegions()
    setRegionsList(regionsList.items)
  }, [])

  return <RegionsContext.Provider value={regionsList}>{children}</RegionsContext.Provider>
}

export default RegionsProvider
